module.exports = __webpack_public_path__ + "static/media/PayMember.80205e4a.png";